import React, { useState } from 'react';
import { Navbar, Container, Button, Popover, OverlayTrigger } from 'react-bootstrap';
import { FaUser } from 'react-icons/fa';
import ScanModal from './items/ScanModal'; 
import { useNavigate } from 'react-router-dom'; 

const Header = ({ isLoggedIn, onLogout }) => {
  const [showPopover, setShowPopover] = useState(false);
  const [showModal, setShowModal] = useState(false); 
  const navigate = useNavigate(); 

  const handleTogglePopover = () => {
    setShowPopover(!showPopover);
  };

  const openModal = () => setShowModal(true); 
  const closeModal = () => setShowModal(false); 

  const handleNavigation = (path) => {
    navigate(path);
    localStorage.setItem('currentPath', path); 
  };

  const popover = (
    <Popover id="popover-basic" style={{ maxWidth: '150px', padding: '5px' }}>
    <Popover.Body style={{ padding: '5px 10px', textAlign: 'center' }}>
      <Button
        variant="danger"
        onClick={onLogout}
        style={{
          padding: '1px 5px',
          fontSize: '0.85rem',
          width: '100%',
          borderRadius: '5px',
        }}
      >
        Logout
      </Button>
    </Popover.Body>
    </Popover>
  );

  return (
    <div id="headercss" className="header-container">
      <Navbar>
        <Container fluid className="header-layout d-flex flex-wrap align-items-center justify-content-between"> {/* Updated to fluid */}
          <div className="header-title"> {/* Updated class name */}
            <Navbar.Brand
              className="header-title text-light mx-5"
              onClick={() => handleNavigation('/items')} // Redirect to Items page
              style={{ cursor: 'pointer' }} // Make it look clickable
            >
              Inventory
            </Navbar.Brand>
          </div>
          <div className="header-actions d-flex align-items-center justify-content-end order-2 order-md-3" style={{ marginLeft: 'auto' }}>
            {isLoggedIn && (
              <>
                <Button
                  variant="primary"
                  className="header-button approval-button" 
                  onClick={() => handleNavigation('/approval')} 
                >
                  Approval
                </Button>
                <Button
                  variant="primary"
                  className="header-button" 
                  onClick={openModal}
                >
                  Inventory Scan
                </Button>
                <OverlayTrigger
                  trigger="click"
                  placement="bottom"
                  show={showPopover}
                  overlay={popover}
                  rootClose
                  onToggle={handleTogglePopover}
                >
                  <Button
                    variant="link"
                    className="header-button logout-button text-light"
                  >
                    <FaUser className="" />
                  </Button>
                </OverlayTrigger>
              </>
            )}
          </div>
        </Container>
      </Navbar>
      <ScanModal showModal={showModal} closeModal={closeModal} /> {/* Add ScanModal */}
    </div>
  );
};

export default Header;
